import React from "react";
import PropTypes from "prop-types";

import { Col, Row } from "../../../components/grid.js";

export default function DeviantBillingAddress({deviantBillingAddress, getFormFieldLabel}) {

  if (!deviantBillingAddress) {
    return (
      <Row>
        <Col tablet={{cols: 4}} desktop={{cols: 4, offset: 2}}>
          —
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col tablet={{cols: 4}} desktop={{cols: 4, offset: 2}}>
          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              {getFormFieldLabel("deviantBillingAddress:name")}
            </div>
            <div>
              {deviantBillingAddress.companyName}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col tablet={{cols: 4}} desktop={{cols: 4, offset: 2}} >
          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              {getFormFieldLabel("deviantBillingAddress:street")}
            </div>
            <div>
              {deviantBillingAddress.street}
            </div>
          </div>

          <div className="b2b-payment__labeled-value b2b-payment__labeled-value--last-child--tablet">
            <div className="b2b-payment__labeled-value__label">
              {getFormFieldLabel("deviantBillingAddress:building")}
            </div>
            <div>
              {deviantBillingAddress.building}
            </div>
          </div>
        </Col>
        <Col tablet={{cols: 4}} desktop={{cols: 4}} >
          <div className="b2b-payment__zip-code-and-city">
            <div className="b2b-payment__labeled-value b2b-payment__labeled-value--zip-code">
              <div className="b2b-payment__labeled-value__label">
                {getFormFieldLabel("deviantBillingAddress:zipCode")}
              </div>
              <div>
                {deviantBillingAddress.zipCode}
              </div>
            </div>

            <div className="b2b-payment__labeled-value">
              <div className="b2b-payment__labeled-value__label">
                {getFormFieldLabel("deviantBillingAddress:city")}
              </div>
              <div>
                {deviantBillingAddress.city}
              </div>
            </div>
          </div>

          <div className="b2b-payment__labeled-value b2b-payment__labeled-value--last-child">
            <div className="b2b-payment__labeled-value__label">
              {getFormFieldLabel("deviantBillingAddress:countryCode")}
            </div>
            <div>
              {deviantBillingAddress.country}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

DeviantBillingAddress.propTypes = {
  deviantBillingAddress: PropTypes.shape({
    companyName: PropTypes.string,
    street: PropTypes.string,
    building: PropTypes.string,
    zipCode: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string
  }),
  getFormFieldLabel: PropTypes.func.isRequired
};
